import React, { FC } from 'react';

type Props = {
  pureUrl: string;
  mailTo: string;
  fullName: string;
  photo: string;
  departments: IDepartment[];
}

const VCardComponent: FC<Props> = ({
  pureUrl, mailTo, fullName, photo, departments,
}) => {
  const renderDepartments = departments.map((d) => {
    const bldStr = d.address.building ? `Bygning ${d.address.building.id}` : '';
    const roomStr = d.address.building.room ? `, ${d.address.building.room}` : '';
    return (
      <React.Fragment key={d.id}>
        <h3 className="org">
          {d.name}
        </h3>
        <p>
          {
            (bldStr !== '') && (
              <>
                <span>
                  {bldStr}
                  {roomStr}
                </span>
                <br />
              </>
            )
          }
          <span className="adr">
            <span className="street-address">
              {d.address.street}
            </span>
            <br />
            <span className="postal-code">
              {d.address.zip}
            </span>
            {' '}
            <span className="locality">
              {d.address.city}
            </span>
          </span>
        </p>
      </React.Fragment>
    );
  });

  return (
    <div className="vcard">
      <h2 className="fn">
        <a className="url" href={pureUrl}>
          {fullName}
        </a>
      </h2>
      <div>
        {
          photo !== '' && (
            <a className="photo" href={pureUrl}>
              <img src={photo} alt={fullName} title={fullName} />
            </a>
          )
        }
        {renderDepartments}
        <p>
          {
            departments[0].phone && (
              <>
                <span>
                  T:
                  {' '}
                </span>
                <span className="tel">
                  {departments[0].phone}
                </span>
                <br />
              </>
            )
          }
          {
            departments[0].mobile && (
              <>
                <span>
                  M:
                  {' '}
                </span>
                <span className="tel">
                  {departments[0].mobile}
                </span>
                <br />
              </>
            )
          }
          {
            departments[0].email && (
              <>
                <span>
                  E:
                  {' '}
                </span>
                <a className="email" href={mailTo}>
                  {departments[0].email}
                </a>
                <br />
              </>
            )
          }
        </p>
      </div>
      <hr />
    </div>
  );
};

VCardComponent.displayName = 'VCardComponent';
export default VCardComponent;
